<template lang="pug">
  .newcomer-goods-card(@click="handleClick")
    SafeImg.goods-img(:src="goodsInfo.imageUrl")
    //- 抵扣类：叠加月卡金额
    .deduct-price-tag(v-if="type === 'deduct' && goodsInfo.price")
      span ¥{{ goodsInfo.price }}续费
    //- 兑换类：奖励金足够时展示「立即领」按钮，出现即触发曝光
    .floating-claim-btn(
      v-if="type === 'exchange' && canClaim"
      v-platform-expose="{ handler: onClaimBtnExpose, once: true }"
    ) 立即领
    //- 攒满时扫光蒙层，覆盖图片+按钮整体区域，5s 后自动停止
    .flash-overlay(v-if="type === 'exchange' && canClaim" v-flash="{ time: 5000 }")
</template>

<script>
import SafeImg from '@/components/safe-img';
import SPM from '../../../../common/spm';

export default {
  name: 'NewcomerGoodsCard',
  components: { SafeImg },
  props: {
    // 商品信息（imageUrl、cost、price、skuId 等）
    goodsInfo: {
      type: Object,
      default: () => ({}),
    },
    // 模板类型：exchange-兑换类，deduct-抵扣类
    type: {
      type: String,
      default: 'exchange',
    },
    // 是否可以领取（奖励金足够）
    canClaim: {
      type: Boolean,
      default: false,
    },
    // 「立即领」按钮曝光埋点参数（由父组件传入）
    claimBtnExposeInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onClaimBtnExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_productGet',
        contentId: 'platform_productGet',
        businessInfo: this.claimBtnExposeInfo,
      });
    },
    handleClick() {
      if (!this.canClaim) return;
      this.$emit('click', this.goodsInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.newcomer-goods-card {
  width: 0.82rem;
  height: 0.54rem;
  border-radius: 0.08rem;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;

  .goods-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 0.08rem;
  }

  /deep/ .safe-img {
    background-color: #d3dae0;
    border-radius: 0.08rem;
  }

  .deduct-price-tag {
    position: absolute;
    left: 0.08rem;
    top: 0.23rem;

    span {
      font-size: 0.1rem;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 400;
      color: #fff;
      opacity: 0.7;
      line-height: 1.4;
    }
  }

  .floating-claim-btn {
    position: absolute;
    bottom: -0.1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.56rem;
    height: 0.22rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffe888;
    border: 0.01rem solid #fff;
    border-radius: 1rem;
    font-size: 0.12rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.9);
    line-height: 1.4;
    cursor: pointer;
    z-index: 2;
  }

  .flash-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -0.06rem;
    border-radius: 0.08rem;
    pointer-events: none;
    z-index: 3;
  }
}
</style>
